export default function () {
	$.nette.ext('recaptcha-load', {
		init: function () {
			observeRecaptchas();

			this.ext('snippets', true).after(() => {
				observeRecaptchas();
			});
		}
	});
}

function observeRecaptchas() {
	const recaptchas = document.querySelectorAll('.g-recaptcha:not([data-observed])');

	if (!('IntersectionObserver' in window)) {
		//fallback – načti hned
		loadRecaptchaIfNotLoaded();
		return;
	}

	for (const el of recaptchas) {
		el.setAttribute('data-observed', 'true');

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					//Jakmile se prvek objeví ve viewportu, načti reCAPTCHA a vykresli ji
					loadRecaptchaIfNotLoaded(() => {
						renderRecaptcha(entry.target);
					});
					obs.unobserve(entry.target);
				}
			});
		}, { rootMargin: '0px 0px 200px 0px' }); // spustí se trochu předem

		observer.observe(el);
	}
}

function loadRecaptchaIfNotLoaded(callback) {
	const url = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';

	if (!window._recaptchaLoadingStarted) {
		window._recaptchaLoadingStarted = true;

		//reCAPTCHA volá tuto globální funkci po načtení
		window.onRecaptchaLoad = () => {
			callback && callback();
		};

		const script = document.createElement('script');
		script.src = url;
		script.async = true;
		script.defer = true;
		document.body.appendChild(script);
	} else if (window.grecaptcha && window.grecaptcha.render) {
		//Pokud už je grecaptcha načtena
		callback && callback();
	}
}

function renderRecaptcha(el) {
	if (el.getAttribute('data-rendered') === 'true') return;

	const sitekey = el.dataset.sitekey;
	if (!sitekey) return;

	const callbackName = el.dataset.callback;
	const action = el.dataset.action;

	//reCAPTCHA do daného elementu
	window.grecaptcha.render(el, {
		sitekey,
		callback: callbackName ? window[callbackName] : undefined,
		action
	});

	el.setAttribute('data-rendered', 'true');
}
